import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#111827] text-white">
      <div className="text-center px-4">
        <h1 className="text-9xl font-bold mb-4">404</h1>
        <h2 className="text-4xl md:text-5xl font-semibold mb-8">
          Page Not Found
        </h2>
        <p className="text-lg md:text-xl mb-8">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/home"
          className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition duration-300"
        >
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
